import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const DermatovenerologyIcon = React.memo(({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(height)}
    viewBox={viewBox}
  >
    <path
      fill={variables['colors-mc-primary']}
      fillOpacity='0.1'
      stroke={variables['colors-mc-primary']}
      d='M80.0713 40C80.0713 61.8153 62.3865 79.5 40.5713 79.5C18.756 79.5 1.07129 61.8153 1.07129 40C1.07129 18.1848 18.756 0.5 40.5713 0.5C62.3865 0.5 80.0713 18.1848 80.0713 40Z'
    />
    <g clipPath='url(#clip0_414_6977)'>
      <path
        d='M64.8913 59.7662L58.1241 52.999L55.1548 55.9684L61.922 62.7355C62.1127 62.9263 62.4218 62.9263 62.6125 62.7355L64.8913 60.4567C65.0819 60.266 65.0819 59.9568 64.8913 59.7662Z'
        fill='#A79BA7'
      />
      <path
        d='M64.8915 59.7663L64.2465 59.1212L62.6128 60.7549C62.4221 60.9457 62.1129 60.9457 61.9223 60.7549L56.2145 55.0471L55.2241 56.0375L61.9223 62.7356C62.113 62.9263 62.4222 62.9263 62.6128 62.7356L64.8915 60.4568C65.0821 60.2661 65.0821 59.9569 64.8915 59.7663Z'
        fill='#918291'
      />
      <path
        d='M36.6871 45.127C36.6871 42.2968 37.7893 39.6359 39.7905 37.6347C41.7918 35.6334 44.4526 34.5312 47.2829 34.5312C48.7005 34.5312 50.0755 34.8078 51.3465 35.3354V28.2849C51.3465 20.9479 45.3986 15 38.0617 15C30.7246 15 24.7769 20.9479 24.7769 28.2849V47.7993C25.5585 47.3441 26.4657 47.0819 27.4337 47.0819H36.8669C36.7484 46.4437 36.6871 45.79 36.6871 45.127Z'
        fill='#883F2E'
      />
      <path
        d='M27.4336 46.9843H28.8746V38.4141H28.589C26.9592 38.4141 25.6379 37.0929 25.6379 35.463V34.1976C25.6379 33.2048 26.1286 32.3271 26.8803 31.7923V30.8643C26.8803 27.9339 28.0081 25.2673 29.8526 23.2734C31.5831 19.0285 35.4458 15.8796 40.1105 15.1574C39.4427 15.0539 38.7585 15 38.0617 15C30.7246 15 24.7769 20.9479 24.7769 28.2849V47.6845C25.5613 47.2396 26.4674 46.9843 27.4336 46.9843Z'
        fill='#6D3326'
      />
      <path
        d='M28.5887 31.3442H28.6498C29.1275 27.1023 32.7363 23.7943 37.1037 23.7943H39.0188C43.3862 23.7943 46.995 27.1022 47.4728 31.3442H47.5339C48.1742 31.3442 48.7659 31.5563 49.2426 31.9138V30.8642C49.2426 24.6889 44.2365 19.6829 38.0612 19.6829C31.8859 19.6829 26.8799 24.6889 26.8799 30.8642V31.9138C27.3566 31.5563 27.9483 31.3442 28.5887 31.3442Z'
        fill='white'
      />
      <path
        d='M28.5627 31.2472C28.7948 29.349 29.6449 27.6419 30.9059 26.3331C32.4463 22.8628 35.7013 20.3227 39.596 19.7881C39.0943 19.7193 38.5823 19.6829 38.0617 19.6829C31.8864 19.6829 26.8804 24.6889 26.8804 30.8642V31.7922C27.356 31.4538 27.9358 31.2527 28.5627 31.2472Z'
        fill='#EAF6FF'
      />
      <path
        d='M47.2828 55.7228C44.4526 55.7228 41.7917 54.6206 39.7904 52.6193C38.2342 51.0631 37.222 49.1079 36.8485 46.9844H27.4335C24.454 46.9844 22.0386 49.3998 22.0386 52.3793V56.8397C26.4238 61.8414 32.8599 65.0001 40.0344 65.0001C45.2848 65.0001 50.1392 63.3075 54.0846 60.4401V53.2515C52.1806 54.851 49.7988 55.7228 47.2828 55.7228Z'
        fill='#FD8087'
      />
      <path
        d='M22.0386 56.8397C23.5187 58.528 25.2318 60.0069 27.129 61.2245V52.3793C27.129 49.3998 29.5444 46.9844 32.5239 46.9844H27.4335C24.454 46.9844 22.0386 49.3998 22.0386 52.3793V56.8397Z'
        fill='#FE646F'
      />
      <path
        d='M36.6873 45.1682C35.7929 45.0375 34.9386 44.7816 34.1431 44.4185V46.9844L37.7956 56.0107C37.8923 56.2496 38.2305 56.2496 38.3271 56.0107L39.7261 52.5536C37.7754 50.5697 36.6979 47.9523 36.6873 45.1682Z'
        fill='#F6A96C'
      />
      <path
        d='M28.5956 35.8024V32.3027C28.5956 31.9451 28.6181 31.5927 28.6611 31.2466H28.5888C26.959 31.2466 25.6377 32.5679 25.6377 34.1977V35.4631C25.6377 37.0929 26.9589 38.4142 28.5888 38.4142H28.9623C28.7237 37.5842 28.5956 36.708 28.5956 35.8024Z'
        fill='#F6A96C'
      />
      <path
        d='M47.5274 34.5344C48.545 34.5573 49.5386 34.7234 50.4854 35.0224V34.1977C50.4854 32.5679 49.1641 31.2466 47.5343 31.2466H47.4619C47.505 31.5927 47.5274 31.9451 47.5274 32.3027V34.5344Z'
        fill='#FFBD86'
      />
      <path
        d='M36.687 45.1269C36.687 42.2967 37.7892 39.6359 39.7904 37.6346C41.7917 35.6334 44.4525 34.5312 47.2828 34.5312C47.3973 34.5312 47.5112 34.5336 47.6251 34.5373V32.3025C47.6251 27.5496 43.7721 23.6965 39.0191 23.6965H37.104C32.3511 23.6965 28.498 27.5496 28.498 32.3025V35.8022C28.498 40.6177 32.0574 44.6013 36.6888 45.2672C36.6881 45.2205 36.687 45.1738 36.687 45.1269Z'
        fill='#FED2A4'
      />
      <path
        d='M36.6287 44.2164C33.6401 42.5993 31.6089 39.4391 31.6089 35.8024V32.3027C31.6089 27.7508 35.1431 24.0249 39.617 23.7178C39.4194 23.7042 39.2201 23.6968 39.0191 23.6968H37.104C32.3511 23.6968 28.498 27.5498 28.498 32.3027V35.8024C28.498 40.5841 32.0073 44.5459 36.5909 45.2534C36.5868 44.9073 36.5994 44.5613 36.6287 44.2164Z'
        fill='#FFBD86'
      />
      <path
        d='M34.4067 32.9076C34.5334 32.1262 34.0026 31.3901 33.2212 31.2634C32.4398 31.1367 31.7037 31.6675 31.577 32.4489C31.4503 33.2303 31.9811 33.9665 32.7625 34.0931C33.5439 34.2198 34.2801 33.689 34.4067 32.9076Z'
        fill='#CA6E59'
      />
      <path
        d='M44.5352 32.9084C44.6618 32.127 44.1311 31.3908 43.3497 31.2641C42.5682 31.1375 41.8321 31.6682 41.7054 32.4496C41.5788 33.231 42.1095 33.9672 42.8909 34.0939C43.6723 34.2205 44.4085 33.6898 44.5352 32.9084Z'
        fill='#CA6E59'
      />
      <path
        d='M37.6445 40.7142C36.7813 40.6228 35.9427 40.2478 35.2825 39.5875C34.9965 39.3016 34.5327 39.3016 34.2468 39.5875C33.9607 39.8736 33.9607 40.3373 34.2468 40.6233C35.0583 41.4349 36.0664 41.9319 37.1192 42.1173C37.2607 41.6371 37.4362 41.1685 37.6445 40.7142Z'
        fill='#CA6E59'
      />
      <path
        d='M38.0614 37.4262C37.8824 37.4262 37.703 37.3609 37.5618 37.2292L36.1283 35.8913C35.891 35.6697 35.8277 35.3186 35.9729 35.0282L37.4064 32.1612C37.5873 31.7995 38.0272 31.6525 38.389 31.8337C38.7508 32.0146 38.8975 32.4545 38.7165 32.8164L37.5279 35.1938L38.5613 36.1583C38.857 36.4343 38.873 36.8977 38.597 37.1935C38.4527 37.348 38.2573 37.4262 38.0614 37.4262Z'
        fill='#CA6E59'
      />
      <path
        d='M58.463 52.108L56.5776 50.2227C56.0996 51.0918 55.4961 51.8985 54.7752 52.6193C54.0543 53.3402 53.2475 53.9438 52.3784 54.4218L54.2639 56.3072C54.4546 56.4979 54.7637 56.4979 54.9544 56.3072L58.4631 52.7985C58.6536 52.6078 58.6536 52.2986 58.463 52.108Z'
        fill='#26A6FE'
      />
      <path
        d='M58.4628 52.1078L57.8096 51.4546L54.9541 54.3101C54.7634 54.5008 54.4543 54.5008 54.2636 54.3101L53.6628 53.7093C53.2724 54.0003 52.8667 54.2613 52.4487 54.4922L54.2636 56.307C54.4543 56.4978 54.7634 56.4978 54.9541 56.307L58.4628 52.7983C58.6534 52.6076 58.6534 52.2984 58.4628 52.1078Z'
        fill='#0593FC'
      />
      <path
        d='M47.2827 53.7695C52.0559 53.7695 55.9253 49.9001 55.9253 45.127C55.9253 40.3538 52.0559 36.4844 47.2827 36.4844C42.5095 36.4844 38.6401 40.3538 38.6401 45.127C38.6401 49.9001 42.5095 53.7695 47.2827 53.7695Z'
        fill='#FED2A4'
      />
      <path
        d='M44.1988 51.2381C40.8237 47.863 40.8237 42.3909 44.1988 39.0157C45.4997 37.7148 47.1125 36.9174 48.7964 36.6194C46.1116 36.1442 43.2457 36.9415 41.1715 39.0157C37.7964 42.3908 37.7964 47.863 41.1715 51.2381C43.2457 53.3124 46.1116 54.1096 48.7964 53.6344C47.1126 53.3364 45.4998 52.539 44.1988 51.2381Z'
        fill='#FFBD86'
      />
      <path
        d='M42.4492 48.0859C43.0155 48.0859 43.4746 47.6269 43.4746 47.0605C43.4746 46.4942 43.0155 46.0352 42.4492 46.0352C41.8829 46.0352 41.4238 46.4942 41.4238 47.0605C41.4238 47.6269 41.8829 48.0859 42.4492 48.0859Z'
        fill='#F6A96C'
      />
      <path
        d='M46.0396 44.4951C46.6059 44.4951 47.0649 44.036 47.0649 43.4697C47.0649 42.9034 46.6059 42.4443 46.0396 42.4443C45.4732 42.4443 45.0142 42.9034 45.0142 43.4697C45.0142 44.036 45.4732 44.4951 46.0396 44.4951Z'
        fill='#FFBD86'
      />
      <path
        d='M49.6304 40.9043C50.1967 40.9043 50.6558 40.4452 50.6558 39.8789C50.6558 39.3126 50.1967 38.8535 49.6304 38.8535C49.0641 38.8535 48.605 39.3126 48.605 39.8789C48.605 40.4452 49.0641 40.9043 49.6304 40.9043Z'
        fill='#FFBD86'
      />
      <path
        d='M47.9043 50.3647C48.4706 50.3647 48.9297 49.9057 48.9297 49.3394C48.9297 48.773 48.4706 48.314 47.9043 48.314C47.338 48.314 46.8789 48.773 46.8789 49.3394C46.8789 49.9057 47.338 50.3647 47.9043 50.3647Z'
        fill='#FFBD86'
      />
      <path
        d='M51.564 46.7048C52.1303 46.7048 52.5894 46.2458 52.5894 45.6794C52.5894 45.1131 52.1303 44.6541 51.564 44.6541C50.9977 44.6541 50.5386 45.1131 50.5386 45.6794C50.5386 46.2458 50.9977 46.7048 51.564 46.7048Z'
        fill='#FFBD86'
      />
      <path
        d='M39.7213 37.5656C35.5454 41.7416 35.5454 48.5123 39.7213 52.6883C43.8973 56.8643 50.668 56.8643 54.844 52.6883C59.02 48.5123 59.02 41.7416 54.844 37.5656C50.668 33.3896 43.8973 33.3896 39.7213 37.5656ZM53.1868 51.0311C49.926 54.2918 44.6394 54.2918 41.3787 51.0311C38.1179 47.7703 38.1179 42.4837 41.3787 39.223C44.6394 35.9622 49.926 35.9622 53.1868 39.223C56.4475 42.4837 56.4475 47.7703 53.1868 51.0311Z'
        fill='#60B7FF'
      />
      <path
        d='M41.7014 52.6882C37.5254 48.5122 37.5254 41.7415 41.7014 37.5655C43.5374 35.7296 45.8748 34.7012 48.2727 34.4795C45.2163 34.197 42.0614 35.2254 39.7213 37.5655C35.5454 41.7415 35.5454 48.5122 39.7213 52.6882C42.0615 55.0283 45.2163 56.0567 48.2727 55.7742C45.8748 55.5525 43.5374 54.5241 41.7014 52.6882Z'
        fill='#26A6FE'
      />
    </g>
    <defs>
      <clipPath id='clip0_414_6977'>
        <rect width='50' height='50' fill='white' transform='translate(15.5713 15)' />
      </clipPath>
    </defs>
  </svg>
));
DermatovenerologyIcon.displayName = 'DermatovenerologyIcon';

export default DermatovenerologyIcon;
